import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "./App.css";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material";
import theme from "./theme/innovaTheme";
import HomePage from "./ui/pages/homePage";
import Layout from "./ui/components/layout";
import Contactanos from "./ui/pages/Contactanos";
import PrivacyPolitics from "./ui/pages/PrivacyPolitics";
import NotFound from "./ui/pages/404";
import React from "react";
import DeleteAccount from "./ui/pages/DeleteAccount";
import PrivacyPoliticsDelta from "./ui/pages/PrivacyPoliticsDelta";
import PrivacyPoliticsSosMuni from "./ui/pages/PrivacyPoliticsSosMuni";
import PrivacyPoliticsSosCColorado from "./ui/pages/PrivacyPoliticsSosCcolorado";
import DeleteAccountSosCerro from "./ui/pages/DeleteAccountSosCerro";
import MarianoMelgarLading from "./ui/pages/MarianoMelgarLanding";
import CerroColoradoLading from "./ui/pages/CerroColoradoLanding";
import PrivacyPoliticsDeltaIos from "./ui/pages/PrivacyPoliticsDeltaIos";
import DeltaLandingPage from "./ui/pages/homeDelta";
import PrivacyPoliticsMpa from "./ui/pages/PrivacyPoliticsMpa";
import DeleteAccountMpa from "./ui/pages/DeleteAccountMpa";
import PrivacyPoliticsUchumayo from "./ui/pages/PrivacyPoliticsUchumayo";
import DeleteAccountUchumayo from "./ui/pages/DeleteAccountUchumayo";
import PrivacyPoliticsPangoa from "./ui/pages/PrivacyPoliticsPangoa";
import DeleteAccountPangoa from "./ui/pages/DeleteAccountPangoa";
import PrivacyPoliticsWally from "./ui/pages/PrivacyPoliticsWally";

function App() {
	return (
		<ThemeProvider theme={theme}>
			<Router>
				<Layout>
					<CssBaseline />
					<Routes>
						<Route exact path="/" element={<HomePage />} />
						<Route exact path="/contacto" element={<Contactanos />} />
						<Route exact path="/privacidad" element={<PrivacyPolitics />} />
						{/* Mariano Melgar  */}
						<Route
							exact
							path="/seguridad/privacidad"
							element={<PrivacyPoliticsSosMuni />}
						/>
						<Route
							exact
							path="/mariano_melgar"
							element={<MarianoMelgarLading />}
						/>
						<Route
							exact
							path="/mariano_melgar/privacidad"
							element={<PrivacyPoliticsSosMuni />}
						/>
						<Route exact path="/deleteaccount" element={<DeleteAccount />} />
						<Route
							exact
							path="/seguridad/serenazgomarianomelgar/deleteaccount"
							element={<DeleteAccount />}
						/>
						{/* Delta Dispatch */}
						<Route
							exact
							path="/deltadispatch/privacidad"
							element={<PrivacyPoliticsDelta />}
						/>

						{/* Delta Dispatch IOS */}
						<Route
							exact
							path="/delta/privacidad"
							element={<PrivacyPoliticsDeltaIos />}
						/>
						<Route exact path="/delta" element={<DeltaLandingPage />} />
						{/* Cerro Colorado */}
						<Route
							exact
							path="/seguridad/sosColorado/privacidad"
							element={<PrivacyPoliticsSosCColorado />}
						/>
						<Route
							exact
							path="/seguridad/sosColorado/deleteaccount/"
							element={<DeleteAccountSosCerro />}
						/>
						<Route
							exact
							path="/cerro_colorado"
							element={<CerroColoradoLading />}
						/>

						{/* MPA */}
						<Route
							exact
							path="/mpa/privacidad"
							element={<PrivacyPoliticsMpa />}
						/>
						<Route
							exact
							path="/mpa/deleteaccount"
							element={<DeleteAccountMpa />}
						/>

						{/* Uchumayo */}
						<Route
							exact
							path="/uchumayo/privacidad"
							element={<PrivacyPoliticsUchumayo />}
						/>
						<Route
							exact
							path="/uchumayo/deleteaccount"
							element={<DeleteAccountUchumayo />}
						/>

						{/* Pangoa */}
						<Route
							exact
							path="/pangoa/privacidad"
							element={<PrivacyPoliticsPangoa />}
						/>
						<Route
							exact
							path="/pangoa/deleteaccount"
							element={<DeleteAccountPangoa />}
						/>

						{/* Wally */}
						<Route
							exact
							path="/wally/privacidad"
							element={<PrivacyPoliticsWally />}
						/>
						<Route exact path="*" element={<NotFound />} />
					</Routes>
				</Layout>
			</Router>
		</ThemeProvider>
	);
}

export default App;
